<template>
    <div class="inline-group">
        <ul>
            <slot />
        </ul>
    </div>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.inline-group {
    > ul {
        margin: -2px -6px;
        > li {
            float: left;
            font-size: 1.4rem;
            line-height: 1.2;
            color: var(--txt-color);
            padding: 2px 6px;
        }
    }

    &--lg {
        > ul {
            margin: -2px -8px;
            > li {
                padding: 2px 8px;
            }
        }
    }

    .clear {
        clear: both;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .inline-group {
        > ul {
            margin: -6px;
            > li {
                padding: 6px;
            }
        }

        &--lg {
            > ul {
                margin: -6px -12px;
                > li {
                    padding: 6px 12px;
                }
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
